// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import * as RoutePath from '../pages/index';
// import Error from '../error/error';
// import TopNav from '../layout/topNavBar';
// import Middleware from '../middleware/middleware';
import RoutesDef from './routeDef';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { loginRequest } from '../auth/authconfig';
import { useEffect } from 'react';

const AuthContent = () => {
  const { instance, accounts, inProgress } = useMsal();
  
  useEffect(() => {
    const Tokengen = async () => {
      // Check if token already exists in sessionStorage (from MSAL's automatic handling)
      const existingToken = sessionStorage.getItem('Token');
      if (existingToken) {
        return; // Token already exists, no need to acquire
      }
      
      if (accounts && accounts.length > 0) {
        try {
          const resp = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          sessionStorage.setItem('Token', resp.accessToken);
        } catch (error) {
          console.error('[Auth] Error acquiring token:', error);
          // If silent token acquisition fails, try redirect
          if (error.errorCode === 'consent_required' || 
              error.errorCode === 'interaction_required' ||
              error.errorCode === 'login_required') {
            instance.acquireTokenRedirect(loginRequest);
          }
        }
      }
    };
    
    // Only run if MSAL is not in startup/login phase
    if (inProgress === 'none') {
      Tokengen();
    }
  }, [instance, accounts, inProgress]);
  
  // Always render routes - let middleware handle token checking
  return <RoutesDef />;
};

const AuthUser = () => {
  const { instance } = useMsal();
  instance.loginRedirect(loginRequest).catch((e) => {});
};

const MainContent = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <AuthContent />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <AuthUser />
      </UnauthenticatedTemplate>
    </>
  );
};

export default function Routing() {
  return <MainContent />;
}
